import { render, staticRenderFns } from "./FullPageDigiMain.vue?vue&type=template&id=2ccb0c90&"
import script from "./FullPageDigiMain.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports